import { render, staticRenderFns } from "./FolderConfirmAssignDialog.vue?vue&type=template&id=bbc220b6&scoped=true"
import script from "./FolderConfirmAssignDialog.vue?vue&type=script&lang=js"
export * from "./FolderConfirmAssignDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderConfirmAssignDialog.vue?vue&type=style&index=0&id=bbc220b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc220b6",
  null
  
)

export default component.exports